<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <div
        v-if="isLoading"
        class=" text-center my-2"
      >
        <b-spinner
          type="grow"
          label="Loading..."
        />
      </div>
      <span v-else>
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="From"
              rules="required"
            >
              <b-form-group
                label="From"
                label-for="From"
              >
                <b-form-input
                  v-model="trainingSessionForm.from"
                  type="date"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="To"
              rules="required"
            >
              <b-form-group
                label="To"
                label-for="To"
              >
                <b-form-input
                  v-model="trainingSessionForm.to"
                  type="date"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="Start Time"
              rules="required"
            >
              <b-form-group
                label="Start Time"
                label-for="Start Time"
              >
                <b-form-input
                  v-model="trainingSessionForm.start_time"
                  type="time"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="End Time"
              rules="required"
            >
              <b-form-group
                label="End Time"
                label-for="End Time"
              >
                <b-form-input
                  v-model="trainingSessionForm.end_time"
                  type="time"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="Training Venue"
              rules="required"
            >
              <b-form-group
                label="Training Venue"
                label-for="Training Venue"
              >
                <b-form-select
                  v-model="trainingSessionForm.training_venue"
                  :options="optionsTrainingVenue"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="trainer"
              rules="required"
            >
              <b-form-group
                label="trainer"
                label-for="trainer"
              >
                <b-form-input
                  v-model="trainingSessionForm.trainer"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="Is Internal"
              rules="required"
            >
              <b-form-group
                label="Is Internal ?"
                label-for="Is Internal ?"
              >
                <b-form-select
                  v-model="trainingSessionForm.is_internal"
                  :options="optionsIsInternal"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="Training"
              rules="required"
            >
              <b-form-group
                label="Training"
                label-for="Training"
              >
                <b-form-select
                  v-model="trainingSessionForm.training_id"
                  :options="optionsTrainingId"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="validationContext"
              name="Attendees"
              rules="required"
            >
              <b-form-group
                label="Attendees"
                label-for="Attendees"
              >
                <v-select
                  v-model="trainingSessionForm.attendee_users"
                  :options="optionsAttendees"
                  :state="getValidationState(validationContext)"
                  multiple
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Attendees Name"
              label-for="Attendees Name"
            >
              <b-form-tags
                v-model="trainingSessionForm.attendee_names"
                multiple
              />
            </b-form-group>
          </b-col>

          <!-- Server Errors -->
          <b-col
            v-if="Object.values(errors).length > 0"
            cols="12"
          >
            <p
              v-for="(error, key, index) in errors"
              :key="index"
              class="text-danger small"
            >
              {{ error.toString() }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            class="mt-50"
          >

            <b-button
              v-if="!loader && $route.params.id"
              variant="primary"
              class="mr-1"
              :disabled="invalid || Object.values(errors).length > 0"
              @click="addtraining ()"
            >
              Save Changes
            </b-button>
            <b-button
              v-if="!loader && !$route.params.id"
              variant="primary"
              class="mr-1"
              :disabled="invalid || Object.values(errors).length > 0"
              @click="addtraining ()"
            >
              Add
            </b-button>
            <b-button
              v-if="loader"
              variant="primary"
              disabled
              class="mr-1"
            >
              <b-spinner
                small
                type="grow"
              />
              Loading...
            </b-button>
          </b-col>
        </b-row>
      </span>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      loader: false,
      isLoading: false,
      validationErrors: {},
      errors: {},
      optionsTrainingVenue: [
        { value: 'online', text: 'Online' },
        { value: 'offline', text: 'Offline' },
      ],
      optionsIsInternal: [
        { value: 1, text: 'Yes' },
        { value: 0, text: 'No' },
      ],
      optionsTrainingId: [],
      optionsAttendees: [],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const trainingSessionForm = ref({})
    return {
      getValidationState,
      trainingSessionForm,
    }
  },
  mounted() {
    this.getTraining()
    setTimeout(() => this.getSingleSessionTraining(), 1000)
  },
  methods: {
    getSingleSessionTraining() {
      this.isLoading = true
      axios.get(`/training-session/${this.$route.params.id}`).then(res => {
        const trainingSessionData = decryptData(res.data.payload).data.trainingSession
        this.trainingSessionForm = trainingSessionData
        // console.log(trainingSessionData)
        this.trainingSessionForm.attendee_users = trainingSessionData.attendee_users.map(item => ({
          value: item.id,
          label: item.name,
        }))
      }).finally(() => {
        this.isLoading = false
      })
    },
    getTraining() {
      this.isLoading = true
      Promise.all([
        axios.get('training'),
        axios.get('https://gulftic-system.fci.group/api/users/list'),
      ]).then(res => {
        const trainingData = decryptData(res[0].data.payload).data.training
        const attendeesData = decryptData(res[1].data.payload).data.users

        this.optionsTrainingId = trainingData.map(item => ({
          value: item.id,
          text: item.name,
        }))
        this.optionsAttendees = attendeesData.map(item => ({
          value: item.id,
          label: item.name,
        }))
      }).finally(() => {
        this.isLoading = false
      })
    },
    addtraining() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')
        Object.entries(this.trainingSessionForm).forEach(([key, value]) => {
          if (['updated_at', 'created_at', 'training', 'id', 'attendees'].includes(key)) {
            return
          }
          if (key === 'attendee_users' && Array.isArray(value)) {
            value.forEach(attendee => {
              formData.append('attendee_users[]', attendee.value) // Send only the ID
            })
          } else if (key === 'attendee_names' && Array.isArray(value)) {
            value.forEach((attendee, index) => {
              formData.append(`attendee_names[${index}]`, attendee) // Send only the ID
            })
          } else {
            formData.append(key, value)
          }
        })

        axios.post(`training-session/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.$router.push({ name: 'sessions-training' })
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      } else {
        this.loader = true
        const formData = new FormData()

        Object.entries(this.trainingSessionForm).forEach(([key, value]) => {
          if (key === 'attendee_users' && Array.isArray(value)) {
            value.forEach(attendee => {
              formData.append('attendee_users[]', attendee.value) // Send only the ID
            })
          } else if (key === 'attendee_names' && Array.isArray(value)) {
            value.forEach((attendee, index) => {
              formData.append(`attendee_names[${index}]`, attendee) // Send only the ID
            })
          } else {
            formData.append(key, value)
          }
        })

        axios.post('training-session', formData).then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'sessions-training' })
            this.$toasted.show('Created Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
